import { Link } from 'react-router-dom';

const BreadCrumb = ({title, innerTitle}) => {
    return (
        <div className="breadcrumb__area" style={{ overflow: "hidden" }}>
            <div
                className="bg-video"
                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex:-1 }}
            >
                <video autoPlay muted loop playsInline style={{ width: "100%", height: "100%", objectFit: "cover" }}>
                    <source src="https://buildgo-react.vercel.app/static/media/banner.b1e80eca5dee07cccccd.mp4" type="video/mp4" />
                </video>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="breadcrumb__area-content">
                            <h2>{title}</h2>
                            <ul>
                                <li><Link to="/">Home</Link><i className="fa-regular fa-angle-right"></i></li>
                                <li>{innerTitle}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BreadCrumb;